import React, { FunctionComponent } from "react";
import styled from "styled-components";

interface PlayProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  children?: React.ReactNode;
}

export const Play: FunctionComponent<PlayProps> = ({
  className,
  children,
  ...props
}) => {
  return (
    <PlayWrapper className={className || ""} {...props}>
      {children}
    </PlayWrapper>
  );
};

const PlayWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.primary};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0;
  padding: 0;
  overflow: hidden;
  transition: opacity
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  > svg {
    fill: ${({ theme }) => theme.colors.background};
    transition: fill
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};
  }
`;
